/**
 * Seam around `window.location.assign` for the central-auth-origin
 * cross-origin redirects (SPA `navigate()` can't leave the origin).
 * jsdom implements `location.assign` as a non-configurable "not
 * implemented" throw, so component tests mock THIS module instead of
 * fighting the Location object.
 */
export function hardNavigate(url: string): void {
  window.location.assign(url)
}

/**
 * `location.replace` variant — used by sign-out's central-origin bounce so
 * the back button never lands on /logout (which would re-run sign-out).
 */
export function hardReplace(url: string): void {
  window.location.replace(url)
}
